<template>
  <div class="clear-filters" data-cy="clear-filters">
    <font-awesome-icon icon="fa-solid fa-filter" />
    <input
      class="btn-filter btn"
      :value="text"
      @click.prevent="onClick"
      type="button"
      :disabled="disabled"
    />
  </div>
</template>

<script setup lang="ts">
export interface Props {
  text?: string;
  disabled?: boolean;
}

const emit = defineEmits<{
  (e: "clearFiltersClicked"): void;
}>();

withDefaults(defineProps<Props>(), {
  text: "Clear All Filters",
  disabled: false,
});

const onClick = function () {
  emit("clearFiltersClicked");
};
</script>

<style lang="scss">
.clear-filters {
  .fa-filter {
    position: absolute;
    top: 10px;
    left: 10px;
    color: #666;
  }
  .btn-filter {
    cursor: pointer;

    &:hover {
      color: #212529;
    }

    &:focus {
      outline: 0;
      box-shadow: 0 0 0 0.25rem rgb(13 110 253 / 25%);
    }
  }
}
</style>
